"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilityCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var material_1 = require("@mui/material");
var UtilityCard = function (_a) {
    var title = _a.title, content = _a.content, actionLabel = _a.actionLabel, onClick = _a.onClick, status = _a.status;
    return ((0, jsx_runtime_1.jsxs)(_1.Card, __assign({ sx: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(_1.CardHeader, { title: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodyXLarge", fontWeight: 600 }, { children: title })), status && (0, jsx_runtime_1.jsx)(_1.StatusIndicator, { enabled: status })] })) }), (0, jsx_runtime_1.jsx)(_1.CardContent, __assign({ sx: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingY: '2.8rem',
                    color: 'primary.400',
                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ spacing: "2.4rem", sx: {
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                    } }, { children: content })) })), actionLabel && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "horizontal", flexItem: true, sx: { borderColor: '#EAF0FE' } }), (0, jsx_runtime_1.jsx)(_1.CardActionArea, __assign({ onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(_1.CardActions, __assign({ sx: {
                                padding: '1.6rem',
                                justifyContent: 'center',
                                color: 'primary.main',
                                '&:hover': {
                                    color: 'common.white',
                                    backgroundColor: 'primary.main',
                                },
                            } }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodyMedium" }, { children: actionLabel })) })) }))] }))] })));
};
exports.UtilityCard = UtilityCard;
